<template>
  <SfButton
    class="product-link-sample"
    :disabled="isProductDisabled"
    @click.native="addToCart"
    v-if="product.sku_muster"
  >
    Gratis Muster anfordern
  </SfButton>
</template>

<script>
import { SfButton } from '@storefront-ui/vue';
import AAddToCart from 'theme/components/atoms/a-add-to-cart';
import { notifications } from '@vue-storefront/core/modules/cart/helpers';
import i18n from '@vue-storefront/i18n'

export default {
  mixins: [
    AAddToCart
  ],
  components: {
    SfButton
  },
  methods: {
    async addToCart () {
      this.$store.dispatch(
        'inventorySources/setIsPickup',
        this.isPickupButton
      )

      try {
        let product = await this.loadSampleProduct()
        if (!product) {
          throw new Error(i18n.t('Product does not exist'))
        }

        const diffLog = await this.$store.dispatch('cart/addItem', {
          productToAdd: Object.assign({}, product, { qty: 1 })
        })
        this.openMicrocart()
        diffLog.clientNotifications.forEach(notificationData => {
          this.$store.dispatch(
            'notification/spawnNotification',
            notificationData,
            { root: true }
          )
        })
      } catch (e) {
        this.$store.dispatch(
          'notification/spawnNotification',
          notifications.createNotification({ type: 'danger', message: e.message }),
          { root: true }
        );
      }
    },
    async loadSampleProduct () {
      return this.$store.dispatch('product/single', {
        options: {
          sku: this.product.sku_muster
        }
      });
    }
  }
}
</script>
